/* One more section in the cart drawer's side column: what the shopper looked
   at on the way here. A second one, related products, was dropped — see the
   note above build() for why it could not be kept full.

   The drawer belongs to an app, so this borrows the app's own classes rather
   than inventing any. One stylesheet then paints both — the app's rows and
   these — and a card looks the same wherever it is written from.

   It used to live in the app's own Custom JS box. The box is not in version
   control, it is lost with the app, and nothing there can be read or tested
   before it is live, which is the whole argument for moving it here. Empty
   that box: while both copies run they take turns writing the same sections.
   The marker attribute is deliberately the one the old copy used, so the old
   copy stands down whenever this one has written. */
/* /cart?no-drawer — a way to look at the cart page itself.

   The app is configured to take that URL over: it opens the drawer as soon
   as the page loads, and its close button runs history.back(), so the page
   underneath can never be read. That is the right behaviour for a shopper,
   who wants the drawer and not a page. It also means the theme's own cart
   page, the one that shows when the app has not booted, cannot be checked
   without this. Nothing links here; it is for looking. */
(function () {
  if (!/[?&]no-drawer(=|&|$)/.test(location.search)) return;
  var css = document.createElement('style');
  css.textContent =
    '#kaching-cart{display:none!important}' +
    'html,body{overflow:visible!important;overflow-x:hidden!important}';
  (document.head || document.documentElement).appendChild(css);
})();

(function () {
  var STORE = 'kurashi_rv'; /* handles, most recent first */
  var MARK = 'data-kx';
  var KEEP = 12;
  var SHOW = 4;

  var TITLE_RECENT = (window.nagiStrings && window.nagiStrings.kaching_recent) || 'Peržiūrėta neseniai';
  var ADD = (window.nagiStrings && window.nagiStrings.kaching_add) || 'Į krepšelį';

  /* The shop prints money as {{amount_with_comma_separator}} €: a dot every
     three digits, a comma before the cents. Intl would give a space for the
     thousands on a Lithuanian locale, which is correct Lithuanian and wrong
     next to every other price in the drawer. */
  function money(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1] + ' €';
  }

  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function handleOf(href) {
    var tail = String(href || '').split('/products/')[1];
    if (!tail) return '';
    try { return decodeURIComponent(tail.split(/[?#]/)[0]); } catch (e) { return tail.split(/[?#]/)[0]; }
  }

  function read() {
    try { return JSON.parse(localStorage.getItem(STORE) || '[]'); } catch (e) { return []; }
  }

  /* ---- What the shopper has been looking at ------------------------------
     Written on product pages, read in the drawer. Handles rather than ids,
     because the drawer looks products up by handle anyway. */
  (function remember() {
    try {
      var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      var here = handleOf(location.pathname);
      if (!meta || !meta.id || !here) return;
      var seen = read().filter(function (x) { return x && x.h !== here; });
      seen.unshift({ h: here });
      localStorage.setItem(STORE, JSON.stringify(seen.slice(0, KEEP)));
    } catch (e) {}
  })();

  /* ---- A card ------------------------------------------------------------
     Built as nodes rather than a string of HTML: the title, the image and the
     link all come from an API response, and assigning them as properties is
     what keeps a quotation mark in a product name from becoming markup. */
  function make(tag, cls) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    return el;
  }

  function card(product) {
    var variant = null;
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) { variant = variants[i]; break; }
    }
    if (!variant) return null;

    var src = product.featured_image || (product.images && product.images[0]) || '';
    if (src && typeof src === 'object') src = src.src || '';

    var wrap = make('div', 'kaching-side-upsell-item-container');
    var item = make('div', 'kaching-side-upsell-item');

    var media = make('div', 'kaching-side-upsell-item__image-container');
    var mediaLink = make('a');
    mediaLink.href = '/products/' + product.handle;
    if (src) {
      var img = make('img', 'kaching-side-upsell-item__image');
      img.src = src;
      img.alt = '';
      img.loading = 'lazy';
      mediaLink.appendChild(img);
    }
    media.appendChild(mediaLink);

    var content = make('div', 'kaching-side-upsell-item__content');
    var title = make('a', 'kaching-side-upsell-item__title');
    title.href = '/products/' + product.handle;
    title.textContent = product.title;

    var prices = make('div', 'kaching-side-upsell-item__price-container');
    var price = make('span', 'kaching-side-upsell-item__price-final');
    price.textContent = money(variant.price);
    prices.appendChild(price);

    var footer = make('div', 'kaching-side-upsell-item__footer');
    var button = make('button', 'kaching-side-upsell-item__add-to-cart');
    button.type = 'button';
    button.textContent = ADD;
    button.addEventListener('click', function () {
      button.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
      })
        .then(function () {
          /* The app redraws from its own state, not from the page, so it has
             to be told. Without this the drawer keeps the old cart until it
             is closed and opened again. */
          if (window.kachingCartApi && kachingCartApi.refreshCart) kachingCartApi.refreshCart();
        })
        .catch(function () {})
        .then(function () { button.disabled = false; });
    });
    footer.appendChild(button);

    content.appendChild(title);
    content.appendChild(prices);
    content.appendChild(footer);
    item.appendChild(media);
    item.appendChild(content);
    wrap.appendChild(item);
    return wrap;
  }

  /* The two sections this script adds sit under the app's own list, and three
     stacked lists made the column taller than two screens. These two are the
     secondary offers, so they lie down: the cards go into a track that scrolls
     sideways, and the column keeps one row instead of three. The app's own
     list stays vertical — it is the offer that matters. */
  var ARROW_PREV = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="10,3 5,8 10,13"></polyline></svg>';
  var ARROW_NEXT = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6,3 11,8 6,13"></polyline></svg>';

  function arrow(dir, label) {
    var b = make('button', 'kaching-side-upsell-arrow');
    b.type = 'button';
    b.setAttribute(dir === 'prev' ? 'data-rail-prev' : 'data-rail-next', '');
    b.setAttribute('aria-label', label);
    b.hidden = true; /* nagi-rail shows it once there is somewhere to go */
    b.innerHTML = dir === 'prev' ? ARROW_PREV : ARROW_NEXT;
    return b;
  }

  function section(key, heading, products) {
    var wrap = document.createElement('div');
    wrap.setAttribute(MARK, key);
    wrap.setAttribute('data-kx-src', 'theme'); /* tells the two copies apart */
    wrap.className = 'kaching-side-upsell-section';
    wrap.setAttribute('data-rail', '');

    /* Heading and arrows share a line, the way the product row upstairs does. */
    var head = make('div', 'kaching-side-upsell-head');
    var title = make('div', 'kaching-cart-side-upsell-carousel__title');
    title.textContent = heading;
    var nav = make('div', 'kaching-side-upsell-nav');
    nav.appendChild(arrow('prev', (window.nagiStrings && window.nagiStrings.kaching_prev) || 'Ankstesnės prekės'));
    nav.appendChild(arrow('next', (window.nagiStrings && window.nagiStrings.kaching_next) || 'Kitos prekės'));
    head.appendChild(title);
    head.appendChild(nav);
    wrap.appendChild(head);

    var track = make('div', 'kaching-side-upsell-track');
    track.setAttribute('data-rail-track', '');
    /* Layout stays in the stylesheet. It was briefly set here too, on a wrong
       reading of why the first card sat flush against the edge — the cause was
       the missing scroll-padding, not a rule that failed to land. Inline
       scroll-snap-type was worse than useless: nagi-rail clears the inline
       value when a drag settles, expecting the stylesheet to give snapping
       back, so setting it here meant the row snapped once and never again. */

    var written = 0;
    for (var i = 0; i < products.length; i++) {
      var node = card(products[i]);
      if (node) { track.appendChild(node); written++; }
    }
    /* The track sits in a box of its own so the stylesheet can lay a fade of
       the column's ground over whichever edge cuts a card — nagi-rail marks
       is-start / is-end / is-overflow on the section (user: a card chopped
       by the column's edge looked wrong). */
    var rail = make('div', 'kaching-side-upsell-rail');
    rail.appendChild(track);
    wrap.appendChild(rail);
    return written ? wrap : null;
  }

  /* A cheap read of what the drawer is showing, so the sections are rebuilt
     when the cart moves and left alone when it has not. The old copy built
     once and never again, which is how a product the shopper had just bought
     stayed in "looked at recently" for the rest of the visit. Only the app's
     own rows count, so writing these sections cannot trigger another pass. */
  function signature(panel) {
    var root = document.getElementById('kaching-cart');
    if (!root) return '';
    var parts = [];
    var lines = root.querySelectorAll('.kaching-cart-item a[href*="/products/"], .kaching-promotion-item a[href*="/products/"]');
    for (var i = 0; i < lines.length; i++) parts.push('c:' + handleOf(lines[i].getAttribute('href')));
    var offers = panel.querySelectorAll('.kaching-side-upsell-item a[href*="/products/"]');
    for (var j = 0; j < offers.length; j++) {
      if (offers[j].closest('[' + MARK + ']')) continue;
      parts.push('u:' + handleOf(offers[j].getAttribute('href')));
    }
    return parts.sort().join('|');
  }

  /* ---- Why there is only one section here now ----------------------------
     There used to be a second one, "Jums taip pat gali patikti". It drew on
     /recommendations, which returns at most nine products for this catalogue,
     and it dropped everything the app's own list was already showing — and
     that list shows eight. Two or three products deep, the section had one
     card left, and adding that card emptied it, so the row vanished under the
     shopper's hand. Nothing in the code was wrong; two sections were sharing
     one nine-product well. The app's list is the related-products section,
     so this file keeps only the one it can fill on its own: the shopper's own
     trail, which no recommendation endpoint has a say in. */
  function build(panel) {
    return getJSON('/cart.js').then(function (cart) {
      var inCart = {};
      var lines = (cart && cart.items) || [];
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].handle) inCart[lines[i].handle] = true;
      }

      /* What is in the cart is dropped, not marked: the shopper is looking at
         it two panels to the right, and offering it again here is noise.

         The whole trail is read rather than the first few, because dropping
         the cart from a short list is what used to empty the row. Twelve
         handles are kept; taking all of them means a shopper who viewed five
         pans and bought two still has three to see. The app's list is not
         subtracted — "looked at recently" makes a different promise from
         "goes well with this", and the same product under both headings is
         the point, not a repetition. */
      var wanted = read().filter(function (x) { return x && x.h && !inCart[x.h]; });

      return Promise.all(
        wanted.map(function (x) { return getJSON('/products/' + encodeURIComponent(x.h) + '.js'); })
      ).then(function (list) {
        var second = list.filter(Boolean).slice(0, SHOW);

        /* Rewriting the row when nothing in it changed is what made it blink:
           every cart change redraws the app's panel, which wakes this script,
           which threw the cards away and built the same ones again. */
        var wantKey = second.map(function (x) { return x.handle; }).join('|');
        var existing = panel.querySelector('[' + MARK + '="rv"]');
        if (existing && existing.getAttribute('data-kx-key') === wantKey) return;

        var old = panel.querySelectorAll('[' + MARK + ']');
        for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);

        var b = section('rv', TITLE_RECENT, second);
        if (b) {
          b.setAttribute('data-kx-key', wantKey);
          panel.appendChild(b);
        }
        if (window.nagiRail && nagiRail.bindAll) nagiRail.bindAll();

        /* Deciding to show nothing still has to be recorded. The marker is
           what the old copy in the app's box checks before it writes, so an
           empty panel would invite it to put its own version back — which is
           how the duplicates survived the first deploy of this file. Left
           this way the theme's copy is the one that decides, whether or not
           that box has been emptied yet. */
        if (!b) {
          var quiet = document.createElement('div');
          quiet.setAttribute(MARK, 'none');
          quiet.setAttribute('data-kx-src', 'theme');
          quiet.style.display = 'none';
          panel.appendChild(quiet);
        }
      });
    });
  }

  /* ---- When to run -------------------------------------------------------
     The app redraws the panel from its own state and takes these sections
     with it, so the work is driven by what the panel looks like rather than
     by any one event. Nothing runs until the drawer is actually on screen:
     it exists on every page, and a cart read on every page view would buy
     nothing. */
  var busy = false;
  var timer = null;
  var last = null;
  var waits = 0;

  /* ---- The promises under the checkout button ----------------------------
     The app's own footer ends in a row of card logos. They say nothing a
     shopper at this point does not assume — the checkout is Shopify's and
     every shop has the same four — while the three things that actually
     answer the hesitation before paying were nowhere in the drawer (user:
     "vietoj ju idedam tuos viso gyvenimo garantija, nemokamas pristatymas
     ir pns"). The icons are hidden in our stylesheet; this puts the
     promises in their place.

     Rebuilt on every tick for the same reason the upsell rows are: the app
     redraws its footer from its own state and takes anything of ours with
     it. */
  /* Each line opens on a word, not on a figure: "14 dienų grąžinimas" put a
     number where the other two put a noun, and the eye caught on it (user).
     "Grąžinimo garantija" drops the figure altogether, which is also what
     the product page's own promise line says — the same promise made twice
     in two wordings reads as two different promises (user). The fourteen
     days are not lost: the returns panel and the footer both carry them,
     and under a checkout button the point is that returning is possible at
     all, not the size of the window.

     No threshold in the delivery line. The drawer already shows what the
     delivery costs on the row above, against this cart; repeating the
     condition under the button argues with a number the shopper can see
     (user). */
  var PROMISES = [
    ['shield', (window.nagiStrings && window.nagiStrings.kaching_warranty) || 'Viso gyvenimo garantija'],
    ['truck', (window.nagiStrings && window.nagiStrings.kaching_delivery) || 'Nemokamas pristatymas'],
    ['clock', (window.nagiStrings && window.nagiStrings.kaching_returns) || 'Grąžinimo garantija']
  ];
  /* All three straight out of pdp-icon.liquid, the set the product page
     draws its promise line with — the same claim should not be made with two
     different marks (user). Their stroke and colour come from the <svg> the
     script writes, so only the shapes are copied. The returns mark is the
     clock the testimonial band already uses for the same fourteen days. */
  var ICONS = {
    shield: '<path d="M12 3.2 19 6v5.6c0 4.2-2.8 7.4-7 9.2-4.2-1.8-7-5-7-9.2V6z" stroke-linejoin="round"/><path d="m8.8 12 2.2 2.2 4.2-4.6" stroke-linecap="round" stroke-linejoin="round"/>',
    truck: '<path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z" stroke-linejoin="round"/><circle cx="7" cy="17.5" r="1.7"/><circle cx="17" cy="17.5" r="1.7"/>',
    clock: '<circle cx="12" cy="12" r="8.4"/><path d="M12 7.4V12l3 1.8" stroke-linecap="round"/>'
  };

  /* Switched off 2026-10-10 (user: "trinam lauk tą promises row, durnai
     atrodo"). The function stays so the row can come back by deleting the
     early return; anything a cached older script left behind is removed. */
  function promises() {
    var foot = document.querySelector('#kaching-cart .kaching-cart__footer');
    if (!foot) return;
    var left = foot.querySelector('[' + MARK + '="promises"]');
    if (left) left.parentNode.removeChild(left);
    return;
    if (foot.querySelector('[' + MARK + '="promises"]')) return;
    var ul = document.createElement('ul');
    ul.setAttribute(MARK, 'promises');
    ul.className = 'kx-promises';
    PROMISES.forEach(function (row) {
      var li = document.createElement('li');
      li.className = 'kx-promises__item';
      li.innerHTML =
        '<svg class="kx-promises__ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="1.4" aria-hidden="true">' +
        ICONS[row[0]] + '</svg><span>' + row[1] + '</span>';
      ul.appendChild(li);
    });
    foot.appendChild(ul);
  }

  /* ---- The reward line ---------------------------------------------------
     While a goal is still ahead the app writes "Dar <b>45,01 €</b> – ir
     <b>Nemokamas pristatymas</b>!" — the sum and the prize both in bold. The
     moment both goals are met it writes "Jums priklauso nemokamas
     pristatymas ir slapta dovana! 🎁" with no emphasis anywhere, so the one
     line that is good news reads flatter than the one asking for more money
     (user: "paboldint gal reik ar kazka akcentuot kas priklauso").

     What is owed is everything after "priklauso" and before the closing
     mark, so that is what is lifted — the sentence is split rather than the
     phrases matched, since the prizes are named in the app's settings and
     will change. Lithuanian-only, like the shop; with no "priklauso" in the
     line nothing is touched. */
  /* ---- The sum the discount is taken off --------------------------------
     The drawer showed a discount and a total and nothing the discount was
     taken off, so the one figure a shopper could check the saving against
     was the one figure missing (user). The app has no row for it: what it
     calls the subtotal is the amount after the discount, which is what it
     prints as "Iš viso".

     Nor is the figure in the cart — Shopify reports no discount at all here
     (`total_discount` is zero). The saving is the app's own arithmetic on
     the compare-at prices, so the number is taken back out of the two the
     app has already printed rather than recomputed from the prices, which
     guarantees the three lines add up on screen whatever the app decides.

     "Suma be nuolaidos", not "Tarpinė suma": Shopify's checkout prints a
     subtotal of its own on the next screen, and that one is the amount
     after the discount. Two different figures under one word, one screen
     apart, is worse than no figure at all. */
  var LABEL_BEFORE = (window.nagiStrings && window.nagiStrings.kaching_before_discount) || 'Suma be nuolaidos';

  function centsOf(txt) {
    var m = String(txt == null ? '' : txt).replace(/[^\d.,-]/g, '');
    if (!m) return null;
    var neg = m.charAt(0) === '-';
    m = m.replace(/-/g, '').replace(/\./g, '').replace(',', '.');
    var n = parseFloat(m);
    if (isNaN(n)) return null;
    return Math.round(n * 100) * (neg ? -1 : 1);
  }

  function beforeDiscount() {
    var foot = document.querySelector('#kaching-cart .kaching-cart__footer');
    if (!foot) return;
    var old = foot.querySelector('.kx-before');
    var disc = foot.querySelector('.kaching-cart__cart-discounts');
    var amount = disc && disc.querySelector('.kaching-cart__cart-discounts-amount');
    var total = foot.querySelector('.kaching-cart__subtotal span');
    var d = amount ? centsOf(amount.textContent) : null;
    var t = total ? centsOf(total.textContent) : null;
    /* No discount, no row: with nothing taken off, the sum before it and
       the total are the same number written twice. */
    if (!d || t == null) {
      if (old) old.parentNode.removeChild(old);
      return;
    }
    var sum = t + Math.abs(d);
    if (old) {
      if (old.getAttribute('data-kx-sum') === String(sum)) return;
      old.parentNode.removeChild(old);
    }
    var row = make('div', 'kx-before');
    row.setAttribute('data-kx-sum', String(sum));
    var l = make('span', 'kx-before__l');
    l.textContent = LABEL_BEFORE;
    var v = make('span', 'kx-before__v');
    v.textContent = money(sum);
    row.appendChild(l);
    row.appendChild(v);
    disc.parentNode.insertBefore(row, disc);
  }

  function rewardLine() {
    var el = document.querySelector('#kaching-cart .kaching-cart__tiered-promotions-bar-text span');
    if (!el || el.dataset.kxBold || el.querySelector('strong, b')) return;
    var t = el.textContent;
    var at = t.indexOf('priklauso ');
    if (at < 0) return;
    var head = t.slice(0, at + 'priklauso '.length);
    var rest = t.slice(at + 'priklauso '.length);
    /* The closing mark and anything after it stay outside the emphasis. */
    var end = rest.search(/[!.?]/);
    var prize = end < 0 ? rest : rest.slice(0, end);
    var tail = end < 0 ? '' : rest.slice(end);
    el.dataset.kxBold = '1';
    el.textContent = '';
    el.appendChild(document.createTextNode(head));
    var b = document.createElement('strong');
    b.textContent = prize;
    el.appendChild(b);
    el.appendChild(document.createTextNode(tail));
  }

  function tick() {
    promises();
    beforeDiscount();
    var panel = document.querySelector('#kaching-cart .kaching-cart__side-upsell');
    if (!panel || busy) return;
    /* The panel exists on every page and has no box until the drawer is
       open, and opening is animated, so the first look after the attribute
       lands can still find nothing. A few more looks cover the animation;
       they stop either when the panel has a box or when the drawer is shut
       again, so a phone — where this column is never laid out at all — is
       not left with a timer running against it. */
    if (!panel.getClientRects().length) {
      if (waits < 12 && document.querySelector('#kaching-cart [open]')) {
        waits++;
        schedule();
      }
      return;
    }
    waits = 0;

    var now = signature(panel);
    if (now === last && panel.querySelector('[' + MARK + ']')) return;

    busy = true;
    last = now;
    build(panel)
      .catch(function () {})
      .then(function () {
        busy = false;
        /* The panel can be redrawn while a build is in flight. */
        if (signature(panel) !== last) schedule();
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(tick, 250);
  }

  (function watch() {
    var root = document.getElementById('kaching-cart');
    if (!root) return setTimeout(watch, 1000);
    /* The promises are written on every mutation, not on the debounced tick
       the upsell rows wait for: the drawer opened, stood there for a quarter
       of a second and then grew a band along its foot, which reads as
       something arriving late rather than as part of the panel (user: "kai
       atsidaro popup'as ta apatine juosta tik veliau atsiranda"). It costs
       one querySelector and returns at once when the band is already there;
       the rows keep their debounce because they fetch. */
    /* Nodes alone are not enough. The app builds the drawer once and then
       opens it by putting `open` on it — no node is added, no node moves,
       and a watch on children alone sleeps straight through the one moment
       that matters. What saved it until now was luck: if the app happened
       to redraw something while the drawer was coming up, that redraw woke
       this, and if it did not, the row simply never appeared (user: "for
       some case sometimes in the upsell cart it doesn't show the perziureta
       neseniai"). The attribute is watched with the nodes. */
    new MutationObserver(function () { promises(); beforeDiscount(); rewardLine(); schedule(); })
      .observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    promises();
    beforeDiscount();
    rewardLine();
    schedule();
  })();
})();
